var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-block__text-block"},[_c('h5',{staticClass:"message-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }